export default __webpack_public_path__ + "static/media/loading.74f9665d.svg";